const CELL = 6;
const DIRS = [[1, 0], [0, 1], [-1, 0], [0, -1]];
const COLOURS = ["#d9a441", "#c8803a", "#e8bf5a", "#b87333", "#f0c869", "#cf8f45"];
const SIGNALS = ["#fffbe6", "#e6fff4", "#fff2b3"];
const rand = (a, b) => a + Math.random() * (b - a);

const board = (w, h) => {
  const c = Object.assign(document.createElement("canvas"), { width: w, height: h });
  const g = c.getContext("2d");
  g.fillStyle = "#0a3a1c";
  g.fillRect(0, 0, w, h);
  g.strokeStyle = "rgba(4,24,12,0.55)";
  g.lineWidth = 2;
  for (let i = 0; i < 60; i++) {
    let x = rand(0, w), y = rand(0, h);
    g.beginPath(); g.moveTo(x, y);
    for (let j = 0; j < 4; j++) { if (j % 2) y += rand(-160, 160); else x += rand(-160, 160); g.lineTo(x, y); }
    g.stroke();
  }
  for (let i = 0; i < 14; i++) {
    const cw = rand(50, 110), ch = rand(30, 70), x = rand(0, w - cw), y = rand(0, h - ch);
    g.fillStyle = "rgba(14,16,15,0.95)";
    g.fillRect(x, y, cw, ch);
    g.fillStyle = "rgba(214,170,90,0.55)";
    for (let p = 6; p < cw - 4; p += 9) { g.fillRect(x + p, y - 5, 4, 5); g.fillRect(x + p, y + ch, 4, 5); }
  }
  g.fillStyle = "rgba(214,170,90,0.35)";
  for (let i = 0; i < 160; i++) { g.beginPath(); g.arc(rand(0, w), rand(0, h), rand(1.5, 3), 0, Math.PI * 2); g.fill(); }
  return c;
};

const free = (s, x, y) => x >= 0 && y >= 0 && x < s.cols && y < s.rows && !s.occ[y * s.cols + x];
const run = (s, x, y, d, max = 30) => {
  let n = 0;
  while (n < max && free(s, x + DIRS[d][0] * (n + 1), y + DIRS[d][1] * (n + 1))) n++;
  return n;
};

const spawn = (s, i) => ({
  x: Math.floor(rand(0.1, 0.9) * s.cols), y: Math.floor(rand(0.1, 0.9) * s.rows), d: Math.floor(Math.random() * 4),
  colour: COLOURS[i % COLOURS.length], signal: SIGNALS[i % SIGNALS.length], trail: [], pads: [], alive: true, fade: 1, acc: 0, speed: rand(1.1, 1.5),
});

const step = (s, c) => {
  const opts = [0, 1, 3].map((t) => (c.d + t) % 4).map((d) => ({ d, r: run(s, c.x, c.y, d) })).filter((o) => o.r > 0);
  if (!opts.length) { c.alive = false; window.__circuitDerez = (window.__circuitDerez || 0) + 1; return; }
  const ahead = opts.find((o) => o.d === c.d);
  const sides = opts.filter((o) => o.d !== c.d && o.r > 10);
  let d = c.d;
  if (!ahead || ahead.r <= 6) d = opts.reduce((a, b) => (b.r > a.r ? b : a)).d;
  else if (sides.length && Math.random() < 0.05) d = sides[Math.floor(Math.random() * sides.length)].d;
  if (d !== c.d) c.pads.push([c.x, c.y]);
  c.d = d;
  c.x += DIRS[d][0];
  c.y += DIRS[d][1];
  s.occ[c.y * s.cols + c.x] = 1;
  c.trail.push([c.x, c.y]);
};

const draw = (ctx, c) => {
  if (c.trail.length < 2) return;
  const px = ([x, y]) => [x * CELL + 3, y * CELL + 3];
  ctx.globalAlpha = c.fade;
  ctx.strokeStyle = c.colour;
  ctx.shadowColor = c.colour;
  ctx.shadowBlur = 8;
  ctx.lineWidth = 3;
  ctx.beginPath();
  c.trail.forEach((p, i) => { const [x, y] = px(p); if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y); });
  ctx.stroke();
  if (c.alive) {
    const tail = c.trail.slice(-16);
    ctx.strokeStyle = c.signal;
    ctx.shadowColor = c.signal;
    ctx.shadowBlur = 26;
    ctx.lineWidth = 3.5;
    ctx.beginPath();
    tail.forEach((p, i) => { const [x, y] = px(p); if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y); });
    ctx.stroke();
    ctx.shadowColor = c.colour;
    ctx.shadowBlur = 8;
  }
  ctx.fillStyle = c.colour;
  c.pads.forEach((p) => { const [x, y] = px(p); ctx.beginPath(); ctx.arc(x, y, 4, 0, Math.PI * 2); ctx.fill(); });
  if (c.alive) {
    const [x, y] = px(c.trail[c.trail.length - 1]);
    ctx.fillStyle = "#ffffff";
    ctx.shadowBlur = 26;
    ctx.beginPath(); ctx.arc(x, y, 4.5, 0, Math.PI * 2); ctx.fill();
  }
  ctx.shadowBlur = 0;
  ctx.globalAlpha = 1;
};

export const circuit = {
  id: "circuit",
  name: "circuit board",
  subtitle: "Bright signals racing along gold traces on a classic green board",
  init(w, h) {
    const s = { cols: Math.ceil(w / CELL), rows: Math.ceil(h / CELL), bg: board(w, h) };
    s.occ = new Uint8Array(s.cols * s.rows);
    s.traces = Array.from({ length: 9 }, (_, i) => spawn(s, i));
    window.__circuitState = s;
    return s;
  },
  draw(ctx, w, h, t, s, p, k) {
    ctx.globalCompositeOperation = "source-over";
    ctx.drawImage(s.bg, 0, 0, w, h);
    s.traces.forEach((c, i) => {
      if (c.alive) {
        c.acc += c.speed * 4.4 * k;
        while (c.acc >= 1 && c.alive) { c.acc -= 1; step(s, c); }
        if (c.trail.length > 700) { const [x, y] = c.trail.shift(); s.occ[y * s.cols + x] = 0; if (c.pads.length && c.pads[0][0] === x && c.pads[0][1] === y) c.pads.shift(); }
      } else {
        c.fade -= 0.015 * k;
        if (c.fade <= 0) { c.trail.forEach(([x, y]) => { s.occ[y * s.cols + x] = 0; }); s.traces[i] = spawn(s, i); }
      }
      draw(ctx, c);
    });
  },
};
